import axiosInstance from "../AxiosInstance";
import { URLS } from "../API/API endpoints";
import { store } from "../Redux/store";
import i18next from "i18next";


export const createMoneyTransfer = async (payload) => {
    // console.log("PAYLAOD CRAET", data);

    try {
        const response = await axiosInstance.post(
            URLS.CREATE_MONEY_TRANSFER,
            payload
        );
        return response.data;
    } catch (error) {
        return error;
    }
};

// ✅ Get Money Transfer List
export const getMoneyTransfers = async (data) => {
    try {
        const payload = {
            is_branch: data?.is_branch,
            store_id: data.store_id,
            start_date: data.start_date,
            end_date: data.end_date,
            from_type: data.from_type || undefined, // optional filter
            limit: data.limit,
            offset: data.offset,
        };

        const response = await axiosInstance.post(
            URLS.GET_MONEY_TRANSFER,
            payload
        );
        return response.data;
    } catch (error) {
        return error;
    }
};

// Edit or Delete Money Transfer
export const editOrDeleteMoneyTransfer = async (payload) => {
    try {

        const response = await axiosInstance.post(
            URLS.EDIT_MONEY_TRANSFER,
            payload
        );
        return response.data;
    } catch (error) {
        return error;
    }
};

export const getTransferBalance = async (payload) => {
    try {
        const res = await axiosInstance.post(URLS.GET_BALANCE, payload);
        return res?.data?.result || null;
    } catch (err) {
        console.error("Error fetching transfer balance:", err);
        throw err;
    }
};

// ✅ Get Excel Export of Money Transfers
export const getMoneyTransferExcel = async (storeId, data) => {
    try {
        const payload = {
            store_id: storeId,
            lang: data.lang,
            start_date: data.start_date,
            end_date: data.end_date,
        };

        const response = await axiosInstance.post(
            URLS.GET_MONEY_TRANSFER_EXCEL,
            payload,
            { responseType: "blob" }
        );
        return response.data;
    } catch (error) {
        return error;
    }
};